<div class="tickets-page">
  <app-header></app-header>

  <div class="tickets-container">
    <div class="tickets-header">
      <h1>My Support Tickets</h1>
    </div>

    <div class="error-container" *ngIf="errorMessage">
      <div class="alert error">
        <div class="alert-content">
          <div class="alert-icon">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="8" x2="12" y2="12"></line>
              <line x1="12" y1="16" x2="12.01" y2="16"></line>
            </svg>
          </div>
          <span>{{ errorMessage }}</span>
        </div>
        <button class="alert-close" (click)="clearErrorMessage()">×</button>
      </div>
    </div>

    <div class="tickets-content" *ngIf="!isLoading">
      <div class="tickets-filters">
        <div class="filter-tabs">
          <button
            *ngFor="let filter of filterOptions"
            class="filter-tab"
            [class.active]="selectedFilter === filter.value"
            (click)="onFilterChange(filter.value)"
          >
            <span class="filter-label">{{ filter.label }}</span>
            <span class="filter-count">{{ filter.count }}</span>
          </button>
        </div>

        <div class="search-container">
          <div class="search-input-wrapper">
            <svg
              class="search-icon"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <circle cx="11" cy="11" r="8"></circle>
              <path d="M21 21l-4.35-4.35"></path>
            </svg>
            <input
              type="text"
              placeholder="Search tickets..."
              class="search-input"
              [value]="searchTerm"
              (input)="onSearchChange($event)"
            />
          </div>
        </div>
      </div>

      <div class="tickets-list" *ngIf="filteredTickets.length > 0">
        <div
          class="ticket-card"
          *ngFor="let ticket of filteredTickets"
          (click)="viewTicket(ticket)"
        >
          <div class="ticket-header">
            <div class="ticket-info">
              <div class="ticket-title">
                <span class="ticket-icon">{{
                  getTicketIcon(ticket.status)
                }}</span>
                <h3>{{ ticket.subject || "No Subject" }}</h3>
                <span
                  class="new-response-badge"
                  *ngIf="hasNewAdminResponse(ticket)"
                  title="New admin response"
                >
                  New
                </span>
              </div>
              <div class="ticket-meta">
                <span class="ticket-id"
                  >ID: {{ ticket.id.substring(0, 8) }}</span
                >
                <span class="ticket-date">{{
                  formatDate(ticket.created_at)
                }}</span>
              </div>
            </div>
            <div class="ticket-status-info">
              <span
                class="ticket-status"
                [ngClass]="getStatusClass(ticket.status)"
              >
                {{ formatStatus(ticket.status) }}
              </span>
              <span
                class="ticket-priority"
                [ngClass]="getPriorityClass(ticket.priority)"
              >
                {{ formatPriority(ticket.priority) }}
              </span>
            </div>
          </div>

          <div class="ticket-preview">
            <p>
              {{ ticket.message.substring(0, 150)
              }}<span *ngIf="ticket.message.length > 150">...</span>
            </p>
          </div>

          <div class="ticket-footer">
            <div class="response-info">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path
                  d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"
                ></path>
              </svg>
              <span>{{ getResponseCountText(ticket.response_count) }}</span>
            </div>
            <div class="last-activity" *ngIf="ticket.last_admin_response">
              <span
                >Last admin response:
                {{ formatDate(ticket.last_admin_response) }}</span
              >
            </div>
          </div>
        </div>
      </div>

      <div
        class="no-tickets-message"
        *ngIf="filteredTickets.length === 0 && tickets.length > 0"
      >
        <div class="no-tickets-icon">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <circle cx="11" cy="11" r="8"></circle>
            <path d="M21 21l-4.35-4.35"></path>
          </svg>
        </div>
        <h3>No tickets found</h3>
        <p>Try adjusting your search or filter criteria.</p>
        <button
          class="clear-filters-btn"
          (click)="selectedFilter = 'all'; searchTerm = ''; applyFilters()"
        >
          Clear Filters
        </button>
      </div>

      <div class="no-tickets-message" *ngIf="tickets.length === 0">
        <div class="no-tickets-icon">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path
              d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
            ></path>
            <polyline points="14 2 14 8 20 8"></polyline>
            <line x1="16" y1="13" x2="8" y2="13"></line>
            <line x1="16" y1="17" x2="8" y2="17"></line>
            <polyline points="10 9 9 9 8 9"></polyline>
          </svg>
        </div>
        <h3>No Support Tickets Yet</h3>
        <p>
          Haven't submitted any support requests yet? Our team is here to help
          with any questions or issues you might have.
        </p>
        <button class="create-first-ticket-btn" (click)="createNewTicket()">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <line x1="12" y1="5" x2="12" y2="19"></line>
            <line x1="5" y1="12" x2="19" y2="12"></line>
          </svg>
          Create Your First Ticket
        </button>
      </div>
    </div>

    <div class="tickets-loading" *ngIf="isLoading">
      <div class="loading-indicator">
        <div class="loading-spinner"></div>
        <p>Loading your support tickets...</p>
      </div>
    </div>
  </div>

  <app-footer></app-footer>
</div>
